import { createContext, Dispatch, ReactNode, SetStateAction, useContext, useEffect, useState } from 'react'
import { clearUserIdentity } from '@cannect/utils/session'
import { IDENTITY_CLEARED_EVENT } from '@cannect/services/api'

const TOKEN_API = '@CANNECT_TOKEN_API'

const TokenApiContext = createContext({} as TokenApiData)

interface TokenApiData {
  tokenApi: string | null
  setTokenApi: Dispatch<SetStateAction<string | null>>
  deleteTokenApi: () => void
}

export function TokenApiProvider({ children }: { children: ReactNode }) {
  const [tokenApi, setTokenApi] = useState(localStorage.getItem(TOKEN_API))
  useEffect(() => {
    if (tokenApi) {
      localStorage.setItem('@CANNECT_TOKEN_API', tokenApi)
    }
  }, [tokenApi])

  // 401 no interceptor do axios limpa o storage; zera também o state.
  useEffect(() => {
    const onIdentityCleared = () => setTokenApi(null)
    window.addEventListener(IDENTITY_CLEARED_EVENT, onIdentityCleared)
    return () => window.removeEventListener(IDENTITY_CLEARED_EVENT, onIdentityCleared)
  }, [])

  function deleteTokenApi() {
    clearUserIdentity()

    setTokenApi(null)
  }

  return (
    <TokenApiContext.Provider
      // eslint-disable-next-line react/jsx-no-constructed-context-values
      value={{
        tokenApi,
        setTokenApi,
        deleteTokenApi
      }}>
      {children}
    </TokenApiContext.Provider>
  )
}

export function useTokenApi(): TokenApiData {
  return useContext(TokenApiContext)
}
